








var jspb=require('google-protobuf');
var goog=jspb;
var global=Function('return this')();

var mti_metadata_pb=require('../../../mti/metadata_pb.js');
var mti_store_cable_state_pb=require('../../../mti/store/cable/state_pb.js');
var mti_store_lock_state_pb=require('../../../mti/store/lock/state_pb.js');
var google_protobuf_timestamp_pb=require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.exportSymbol('proto.mti.store.nxdi.ShellCableType',null,global);
goog.exportSymbol('proto.mti.store.nxdi.ShellType',null,global);
goog.exportSymbol('proto.mti.store.nxdi.State',null,global);











proto.mti.store.nxdi.State=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.store.nxdi.State,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.store.nxdi.State.displayName='proto.mti.store.nxdi.State';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.store.nxdi.State.prototype.toObject=function(opt_includeInstance){
return proto.mti.store.nxdi.State.toObject(opt_includeInstance,this);
};











proto.mti.store.nxdi.State.toObject=function(includeInstance,msg){
var f,obj={
metadata:(f=msg.getMetadata())&&mti_metadata_pb.Metadata.toObject(includeInstance,f),
storeId:jspb.Message.getFieldWithDefault(msg,2,0),
puckSerialNumber:jspb.Message.getFieldWithDefault(msg,3,""),
baseSerialNumber:jspb.Message.getFieldWithDefault(msg,4,""),
stateUuid:msg.getStateUuid_asB64(),
stateUpdatedAt:(f=msg.getStateUpdatedAt())&&google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance,f),
keySerialNumber:jspb.Message.getFieldWithDefault(msg,7,""),
keyType:jspb.Message.getFieldWithDefault(msg,8,0),
cable0Type:jspb.Message.getFieldWithDefault(msg,9,0),
cable1Type:jspb.Message.getFieldWithDefault(msg,10,0),
shellType:jspb.Message.getFieldWithDefault(msg,11,0),
shellCableType:jspb.Message.getFieldWithDefault(msg,12,0),
puckBatteryLevel:jspb.Message.getFieldWithDefault(msg,13,0),
baseBatteryLevel:jspb.Message.getFieldWithDefault(msg,14,0),
cableVbusCurrent:jspb.Message.getFieldWithDefault(msg,15,0),
shellOutputCurrent:jspb.Message.getFieldWithDefault(msg,16,0),
shellOutputVoltage:jspb.Message.getFieldWithDefault(msg,17,0),
shellBatteryTemperature:jspb.Message.getFieldWithDefault(msg,18,0),
shellBatteryChargeCycles:jspb.Message.getFieldWithDefault(msg,19,0),
puckModel:jspb.Message.getFieldWithDefault(msg,20,""),
puckHardwareVersion:jspb.Message.getFieldWithDefault(msg,21,""),
puckFirmwareVersion:jspb.Message.getFieldWithDefault(msg,22,""),
baseModel:jspb.Message.getFieldWithDefault(msg,23,""),
baseHardwareVersion:jspb.Message.getFieldWithDefault(msg,24,""),
baseFirmwareVersion:jspb.Message.getFieldWithDefault(msg,25,""),
puckLostCommunication:jspb.Message.getFieldWithDefault(msg,26,false),
puckIdentifying:jspb.Message.getFieldWithDefault(msg,27,false),
puckLifted:jspb.Message.getFieldWithDefault(msg,28,false),
puckCharging:jspb.Message.getFieldWithDefault(msg,29,false),
puckPowered:jspb.Message.getFieldWithDefault(msg,30,false),
puckDeepSleep:jspb.Message.getFieldWithDefault(msg,31,false),
puckShutdown:jspb.Message.getFieldWithDefault(msg,32,false),
puckTether:jspb.Message.getFieldWithDefault(msg,33,false),
puckSwitchOpen:jspb.Message.getFieldWithDefault(msg,34,false),
baseLostCommunication:jspb.Message.getFieldWithDefault(msg,35,false),
baseCharging:jspb.Message.getFieldWithDefault(msg,36,false),
basePowered:jspb.Message.getFieldWithDefault(msg,37,false),
baseShutdown:jspb.Message.getFieldWithDefault(msg,38,false),
baseOutputDisabled:jspb.Message.getFieldWithDefault(msg,39,false),
baseOutputOvercurrent:jspb.Message.getFieldWithDefault(msg,40,false),
baseButtonLifted:jspb.Message.getFieldWithDefault(msg,41,false),
shellLostCommunication:jspb.Message.getFieldWithDefault(msg,42,false),
shellCharging:jspb.Message.getFieldWithDefault(msg,43,false),
shellPowered:jspb.Message.getFieldWithDefault(msg,44,false),
shellShutdown:jspb.Message.getFieldWithDefault(msg,45,false),
shellOutputDisabled:jspb.Message.getFieldWithDefault(msg,46,false),
shellOutputOvercurrent:jspb.Message.getFieldWithDefault(msg,47,false),
shellBatterySwollenAlarming:jspb.Message.getFieldWithDefault(msg,48,false),
shellBatteryChargeCycleAlert:jspb.Message.getFieldWithDefault(msg,49,false),
armed:jspb.Message.getFieldWithDefault(msg,50,false),
keyInserted:jspb.Message.getFieldWithDefault(msg,51,false),
silentAlarming:jspb.Message.getFieldWithDefault(msg,52,false),
puckSwitchAlarming:jspb.Message.getFieldWithDefault(msg,53,false),
tetherAlarming:jspb.Message.getFieldWithDefault(msg,54,false),
cable0Alarming:jspb.Message.getFieldWithDefault(msg,55,false),
cable1Alarming:jspb.Message.getFieldWithDefault(msg,56,false),
demoMode:jspb.Message.getFieldWithDefault(msg,57,false),
cable0SwitchOpen:jspb.Message.getFieldWithDefault(msg,58,false),
cable1SwitchOpen:jspb.Message.getFieldWithDefault(msg,59,false),
cableVbusDisabled:jspb.Message.getFieldWithDefault(msg,60,false),
cableVbusFault:jspb.Message.getFieldWithDefault(msg,61,false)};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.store.nxdi.State.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.store.nxdi.State();
return proto.mti.store.nxdi.State.deserializeBinaryFromReader(msg,reader);
};









proto.mti.store.nxdi.State.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=new mti_metadata_pb.Metadata();
reader.readMessage(value,mti_metadata_pb.Metadata.deserializeBinaryFromReader);
msg.setMetadata(value);
break;
case 2:
var value=reader.readUint64();
msg.setStoreId(value);
break;
case 3:
var value=reader.readString();
msg.setPuckSerialNumber(value);
break;
case 4:
var value=reader.readString();
msg.setBaseSerialNumber(value);
break;
case 5:
var value=reader.readBytes();
msg.setStateUuid(value);
break;
case 6:
var value=new google_protobuf_timestamp_pb.Timestamp();
reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
msg.setStateUpdatedAt(value);
break;
case 7:
var value=reader.readString();
msg.setKeySerialNumber(value);
break;
case 8:
var value=reader.readEnum();
msg.setKeyType(value);
break;
case 9:
var value=reader.readEnum();
msg.setCable0Type(value);
break;
case 10:
var value=reader.readEnum();
msg.setCable1Type(value);
break;
case 11:
var value=reader.readEnum();
msg.setShellType(value);
break;
case 12:
var value=reader.readEnum();
msg.setShellCableType(value);
break;
case 13:
var value=reader.readUint32();
msg.setPuckBatteryLevel(value);
break;
case 14:
var value=reader.readUint32();
msg.setBaseBatteryLevel(value);
break;
case 15:
var value=reader.readUint32();
msg.setCableVbusCurrent(value);
break;
case 16:
var value=reader.readUint32();
msg.setShellOutputCurrent(value);
break;
case 17:
var value=reader.readUint32();
msg.setShellOutputVoltage(value);
break;
case 18:
var value=reader.readUint32();
msg.setShellBatteryTemperature(value);
break;
case 19:
var value=reader.readUint32();
msg.setShellBatteryChargeCycles(value);
break;
case 20:
var value=reader.readString();
msg.setPuckModel(value);
break;
case 21:
var value=reader.readString();
msg.setPuckHardwareVersion(value);
break;
case 22:
var value=reader.readString();
msg.setPuckFirmwareVersion(value);
break;
case 23:
var value=reader.readString();
msg.setBaseModel(value);
break;
case 24:
var value=reader.readString();
msg.setBaseHardwareVersion(value);
break;
case 25:
var value=reader.readString();
msg.setBaseFirmwareVersion(value);
break;
case 26:
var value=reader.readBool();
msg.setPuckLostCommunication(value);
break;
case 27:
var value=reader.readBool();
msg.setPuckIdentifying(value);
break;
case 28:
var value=reader.readBool();
msg.setPuckLifted(value);
break;
case 29:
var value=reader.readBool();
msg.setPuckCharging(value);
break;
case 30:
var value=reader.readBool();
msg.setPuckPowered(value);
break;
case 31:
var value=reader.readBool();
msg.setPuckDeepSleep(value);
break;
case 32:
var value=reader.readBool();
msg.setPuckShutdown(value);
break;
case 33:
var value=reader.readBool();
msg.setPuckTether(value);
break;
case 34:
var value=reader.readBool();
msg.setPuckSwitchOpen(value);
break;
case 35:
var value=reader.readBool();
msg.setBaseLostCommunication(value);
break;
case 36:
var value=reader.readBool();
msg.setBaseCharging(value);
break;
case 37:
var value=reader.readBool();
msg.setBasePowered(value);
break;
case 38:
var value=reader.readBool();
msg.setBaseShutdown(value);
break;
case 39:
var value=reader.readBool();
msg.setBaseOutputDisabled(value);
break;
case 40:
var value=reader.readBool();
msg.setBaseOutputOvercurrent(value);
break;
case 41:
var value=reader.readBool();
msg.setBaseButtonLifted(value);
break;
case 42:
var value=reader.readBool();
msg.setShellLostCommunication(value);
break;
case 43:
var value=reader.readBool();
msg.setShellCharging(value);
break;
case 44:
var value=reader.readBool();
msg.setShellPowered(value);
break;
case 45:
var value=reader.readBool();
msg.setShellShutdown(value);
break;
case 46:
var value=reader.readBool();
msg.setShellOutputDisabled(value);
break;
case 47:
var value=reader.readBool();
msg.setShellOutputOvercurrent(value);
break;
case 48:
var value=reader.readBool();
msg.setShellBatterySwollenAlarming(value);
break;
case 49:
var value=reader.readBool();
msg.setShellBatteryChargeCycleAlert(value);
break;
case 50:
var value=reader.readBool();
msg.setArmed(value);
break;
case 51:
var value=reader.readBool();
msg.setKeyInserted(value);
break;
case 52:
var value=reader.readBool();
msg.setSilentAlarming(value);
break;
case 53:
var value=reader.readBool();
msg.setPuckSwitchAlarming(value);
break;
case 54:
var value=reader.readBool();
msg.setTetherAlarming(value);
break;
case 55:
var value=reader.readBool();
msg.setCable0Alarming(value);
break;
case 56:
var value=reader.readBool();
msg.setCable1Alarming(value);
break;
case 57:
var value=reader.readBool();
msg.setDemoMode(value);
break;
case 58:
var value=reader.readBool();
msg.setCable0SwitchOpen(value);
break;
case 59:
var value=reader.readBool();
msg.setCable1SwitchOpen(value);
break;
case 60:
var value=reader.readBool();
msg.setCableVbusDisabled(value);
break;
case 61:
var value=reader.readBool();
msg.setCableVbusFault(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.store.nxdi.State.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.store.nxdi.State.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.store.nxdi.State.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getMetadata();
if(f!=null){
writer.writeMessage(
1,
f,
mti_metadata_pb.Metadata.serializeBinaryToWriter);

}
f=message.getStoreId();
if(f!==0){
writer.writeUint64(
2,
f);

}
f=message.getPuckSerialNumber();
if(f.length>0){
writer.writeString(
3,
f);

}
f=message.getBaseSerialNumber();
if(f.length>0){
writer.writeString(
4,
f);

}
f=message.getStateUuid_asU8();
if(f.length>0){
writer.writeBytes(
5,
f);

}
f=message.getStateUpdatedAt();
if(f!=null){
writer.writeMessage(
6,
f,
google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);

}
f=message.getKeySerialNumber();
if(f.length>0){
writer.writeString(
7,
f);

}
f=message.getKeyType();
if(f!==0.0){
writer.writeEnum(
8,
f);

}
f=message.getCable0Type();
if(f!==0.0){
writer.writeEnum(
9,
f);

}
f=message.getCable1Type();
if(f!==0.0){
writer.writeEnum(
10,
f);

}
f=message.getShellType();
if(f!==0.0){
writer.writeEnum(
11,
f);

}
f=message.getShellCableType();
if(f!==0.0){
writer.writeEnum(
12,
f);

}
f=message.getPuckBatteryLevel();
if(f!==0){
writer.writeUint32(
13,
f);

}
f=message.getBaseBatteryLevel();
if(f!==0){
writer.writeUint32(
14,
f);

}
f=message.getCableVbusCurrent();
if(f!==0){
writer.writeUint32(
15,
f);

}
f=message.getShellOutputCurrent();
if(f!==0){
writer.writeUint32(
16,
f);

}
f=message.getShellOutputVoltage();
if(f!==0){
writer.writeUint32(
17,
f);

}
f=message.getShellBatteryTemperature();
if(f!==0){
writer.writeUint32(
18,
f);

}
f=message.getShellBatteryChargeCycles();
if(f!==0){
writer.writeUint32(
19,
f);

}
f=message.getPuckModel();
if(f.length>0){
writer.writeString(
20,
f);

}
f=message.getPuckHardwareVersion();
if(f.length>0){
writer.writeString(
21,
f);

}
f=message.getPuckFirmwareVersion();
if(f.length>0){
writer.writeString(
22,
f);

}
f=message.getBaseModel();
if(f.length>0){
writer.writeString(
23,
f);

}
f=message.getBaseHardwareVersion();
if(f.length>0){
writer.writeString(
24,
f);

}
f=message.getBaseFirmwareVersion();
if(f.length>0){
writer.writeString(
25,
f);

}
f=message.getPuckLostCommunication();
if(f){
writer.writeBool(
26,
f);

}
f=message.getPuckIdentifying();
if(f){
writer.writeBool(
27,
f);

}
f=message.getPuckLifted();
if(f){
writer.writeBool(
28,
f);

}
f=message.getPuckCharging();
if(f){
writer.writeBool(
29,
f);

}
f=message.getPuckPowered();
if(f){
writer.writeBool(
30,
f);

}
f=message.getPuckDeepSleep();
if(f){
writer.writeBool(
31,
f);

}
f=message.getPuckShutdown();
if(f){
writer.writeBool(
32,
f);

}
f=message.getPuckTether();
if(f){
writer.writeBool(
33,
f);

}
f=message.getPuckSwitchOpen();
if(f){
writer.writeBool(
34,
f);

}
f=message.getBaseLostCommunication();
if(f){
writer.writeBool(
35,
f);

}
f=message.getBaseCharging();
if(f){
writer.writeBool(
36,
f);

}
f=message.getBasePowered();
if(f){
writer.writeBool(
37,
f);

}
f=message.getBaseShutdown();
if(f){
writer.writeBool(
38,
f);

}
f=message.getBaseOutputDisabled();
if(f){
writer.writeBool(
39,
f);

}
f=message.getBaseOutputOvercurrent();
if(f){
writer.writeBool(
40,
f);

}
f=message.getBaseButtonLifted();
if(f){
writer.writeBool(
41,
f);

}
f=message.getShellLostCommunication();
if(f){
writer.writeBool(
42,
f);

}
f=message.getShellCharging();
if(f){
writer.writeBool(
43,
f);

}
f=message.getShellPowered();
if(f){
writer.writeBool(
44,
f);

}
f=message.getShellShutdown();
if(f){
writer.writeBool(
45,
f);

}
f=message.getShellOutputDisabled();
if(f){
writer.writeBool(
46,
f);

}
f=message.getShellOutputOvercurrent();
if(f){
writer.writeBool(
47,
f);

}
f=message.getShellBatterySwollenAlarming();
if(f){
writer.writeBool(
48,
f);

}
f=message.getShellBatteryChargeCycleAlert();
if(f){
writer.writeBool(
49,
f);

}
f=message.getArmed();
if(f){
writer.writeBool(
50,
f);

}
f=message.getKeyInserted();
if(f){
writer.writeBool(
51,
f);

}
f=message.getSilentAlarming();
if(f){
writer.writeBool(
52,
f);

}
f=message.getPuckSwitchAlarming();
if(f){
writer.writeBool(
53,
f);

}
f=message.getTetherAlarming();
if(f){
writer.writeBool(
54,
f);

}
f=message.getCable0Alarming();
if(f){
writer.writeBool(
55,
f);

}
f=message.getCable1Alarming();
if(f){
writer.writeBool(
56,
f);

}
f=message.getDemoMode();
if(f){
writer.writeBool(
57,
f);

}
f=message.getCable0SwitchOpen();
if(f){
writer.writeBool(
58,
f);

}
f=message.getCable1SwitchOpen();
if(f){
writer.writeBool(
59,
f);

}
f=message.getCableVbusDisabled();
if(f){
writer.writeBool(
60,
f);

}
f=message.getCableVbusFault();
if(f){
writer.writeBool(
61,
f);

}
};






proto.mti.store.nxdi.State.prototype.getMetadata=function(){
return(
jspb.Message.getWrapperField(this,mti_metadata_pb.Metadata,1));
};



proto.mti.store.nxdi.State.prototype.setMetadata=function(value){
jspb.Message.setWrapperField(this,1,value);
};


proto.mti.store.nxdi.State.prototype.clearMetadata=function(){
this.setMetadata(undefined);
};






proto.mti.store.nxdi.State.prototype.hasMetadata=function(){
return jspb.Message.getField(this,1)!=null;
};






proto.mti.store.nxdi.State.prototype.getStoreId=function(){
return jspb.Message.getFieldWithDefault(this,2,0);
};



proto.mti.store.nxdi.State.prototype.setStoreId=function(value){
jspb.Message.setProto3IntField(this,2,value);
};






proto.mti.store.nxdi.State.prototype.getPuckSerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,3,"");
};



proto.mti.store.nxdi.State.prototype.setPuckSerialNumber=function(value){
jspb.Message.setProto3StringField(this,3,value);
};






proto.mti.store.nxdi.State.prototype.getBaseSerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,4,"");
};



proto.mti.store.nxdi.State.prototype.setBaseSerialNumber=function(value){
jspb.Message.setProto3StringField(this,4,value);
};






proto.mti.store.nxdi.State.prototype.getStateUuid=function(){
return jspb.Message.getFieldWithDefault(this,5,"");
};







proto.mti.store.nxdi.State.prototype.getStateUuid_asB64=function(){
return jspb.Message.bytesAsB64(
this.getStateUuid());
};









proto.mti.store.nxdi.State.prototype.getStateUuid_asU8=function(){
return jspb.Message.bytesAsU8(
this.getStateUuid());
};



proto.mti.store.nxdi.State.prototype.setStateUuid=function(value){
jspb.Message.setProto3BytesField(this,5,value);
};






proto.mti.store.nxdi.State.prototype.getStateUpdatedAt=function(){
return(
jspb.Message.getWrapperField(this,google_protobuf_timestamp_pb.Timestamp,6));
};



proto.mti.store.nxdi.State.prototype.setStateUpdatedAt=function(value){
jspb.Message.setWrapperField(this,6,value);
};


proto.mti.store.nxdi.State.prototype.clearStateUpdatedAt=function(){
this.setStateUpdatedAt(undefined);
};






proto.mti.store.nxdi.State.prototype.hasStateUpdatedAt=function(){
return jspb.Message.getField(this,6)!=null;
};






proto.mti.store.nxdi.State.prototype.getKeySerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,7,"");
};



proto.mti.store.nxdi.State.prototype.setKeySerialNumber=function(value){
jspb.Message.setProto3StringField(this,7,value);
};






proto.mti.store.nxdi.State.prototype.getKeyType=function(){
return jspb.Message.getFieldWithDefault(this,8,0);
};



proto.mti.store.nxdi.State.prototype.setKeyType=function(value){
jspb.Message.setProto3EnumField(this,8,value);
};






proto.mti.store.nxdi.State.prototype.getCable0Type=function(){
return jspb.Message.getFieldWithDefault(this,9,0);
};



proto.mti.store.nxdi.State.prototype.setCable0Type=function(value){
jspb.Message.setProto3EnumField(this,9,value);
};






proto.mti.store.nxdi.State.prototype.getCable1Type=function(){
return jspb.Message.getFieldWithDefault(this,10,0);
};



proto.mti.store.nxdi.State.prototype.setCable1Type=function(value){
jspb.Message.setProto3EnumField(this,10,value);
};






proto.mti.store.nxdi.State.prototype.getShellType=function(){
return jspb.Message.getFieldWithDefault(this,11,0);
};



proto.mti.store.nxdi.State.prototype.setShellType=function(value){
jspb.Message.setProto3EnumField(this,11,value);
};






proto.mti.store.nxdi.State.prototype.getShellCableType=function(){
return jspb.Message.getFieldWithDefault(this,12,0);
};



proto.mti.store.nxdi.State.prototype.setShellCableType=function(value){
jspb.Message.setProto3EnumField(this,12,value);
};






proto.mti.store.nxdi.State.prototype.getPuckBatteryLevel=function(){
return jspb.Message.getFieldWithDefault(this,13,0);
};



proto.mti.store.nxdi.State.prototype.setPuckBatteryLevel=function(value){
jspb.Message.setProto3IntField(this,13,value);
};






proto.mti.store.nxdi.State.prototype.getBaseBatteryLevel=function(){
return jspb.Message.getFieldWithDefault(this,14,0);
};



proto.mti.store.nxdi.State.prototype.setBaseBatteryLevel=function(value){
jspb.Message.setProto3IntField(this,14,value);
};






proto.mti.store.nxdi.State.prototype.getCableVbusCurrent=function(){
return jspb.Message.getFieldWithDefault(this,15,0);
};



proto.mti.store.nxdi.State.prototype.setCableVbusCurrent=function(value){
jspb.Message.setProto3IntField(this,15,value);
};






proto.mti.store.nxdi.State.prototype.getShellOutputCurrent=function(){
return jspb.Message.getFieldWithDefault(this,16,0);
};



proto.mti.store.nxdi.State.prototype.setShellOutputCurrent=function(value){
jspb.Message.setProto3IntField(this,16,value);
};






proto.mti.store.nxdi.State.prototype.getShellOutputVoltage=function(){
return jspb.Message.getFieldWithDefault(this,17,0);
};



proto.mti.store.nxdi.State.prototype.setShellOutputVoltage=function(value){
jspb.Message.setProto3IntField(this,17,value);
};






proto.mti.store.nxdi.State.prototype.getShellBatteryTemperature=function(){
return jspb.Message.getFieldWithDefault(this,18,0);
};



proto.mti.store.nxdi.State.prototype.setShellBatteryTemperature=function(value){
jspb.Message.setProto3IntField(this,18,value);
};






proto.mti.store.nxdi.State.prototype.getShellBatteryChargeCycles=function(){
return jspb.Message.getFieldWithDefault(this,19,0);
};



proto.mti.store.nxdi.State.prototype.setShellBatteryChargeCycles=function(value){
jspb.Message.setProto3IntField(this,19,value);
};






proto.mti.store.nxdi.State.prototype.getPuckModel=function(){
return jspb.Message.getFieldWithDefault(this,20,"");
};



proto.mti.store.nxdi.State.prototype.setPuckModel=function(value){
jspb.Message.setProto3StringField(this,20,value);
};






proto.mti.store.nxdi.State.prototype.getPuckHardwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,21,"");
};



proto.mti.store.nxdi.State.prototype.setPuckHardwareVersion=function(value){
jspb.Message.setProto3StringField(this,21,value);
};






proto.mti.store.nxdi.State.prototype.getPuckFirmwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,22,"");
};



proto.mti.store.nxdi.State.prototype.setPuckFirmwareVersion=function(value){
jspb.Message.setProto3StringField(this,22,value);
};






proto.mti.store.nxdi.State.prototype.getBaseModel=function(){
return jspb.Message.getFieldWithDefault(this,23,"");
};



proto.mti.store.nxdi.State.prototype.setBaseModel=function(value){
jspb.Message.setProto3StringField(this,23,value);
};






proto.mti.store.nxdi.State.prototype.getBaseHardwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,24,"");
};



proto.mti.store.nxdi.State.prototype.setBaseHardwareVersion=function(value){
jspb.Message.setProto3StringField(this,24,value);
};






proto.mti.store.nxdi.State.prototype.getBaseFirmwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,25,"");
};



proto.mti.store.nxdi.State.prototype.setBaseFirmwareVersion=function(value){
jspb.Message.setProto3StringField(this,25,value);
};








proto.mti.store.nxdi.State.prototype.getPuckLostCommunication=function(){
return jspb.Message.getFieldWithDefault(this,26,false);
};



proto.mti.store.nxdi.State.prototype.setPuckLostCommunication=function(value){
jspb.Message.setProto3BooleanField(this,26,value);
};








proto.mti.store.nxdi.State.prototype.getPuckIdentifying=function(){
return jspb.Message.getFieldWithDefault(this,27,false);
};



proto.mti.store.nxdi.State.prototype.setPuckIdentifying=function(value){
jspb.Message.setProto3BooleanField(this,27,value);
};








proto.mti.store.nxdi.State.prototype.getPuckLifted=function(){
return jspb.Message.getFieldWithDefault(this,28,false);
};



proto.mti.store.nxdi.State.prototype.setPuckLifted=function(value){
jspb.Message.setProto3BooleanField(this,28,value);
};








proto.mti.store.nxdi.State.prototype.getPuckCharging=function(){
return jspb.Message.getFieldWithDefault(this,29,false);
};



proto.mti.store.nxdi.State.prototype.setPuckCharging=function(value){
jspb.Message.setProto3BooleanField(this,29,value);
};








proto.mti.store.nxdi.State.prototype.getPuckPowered=function(){
return jspb.Message.getFieldWithDefault(this,30,false);
};



proto.mti.store.nxdi.State.prototype.setPuckPowered=function(value){
jspb.Message.setProto3BooleanField(this,30,value);
};








proto.mti.store.nxdi.State.prototype.getPuckDeepSleep=function(){
return jspb.Message.getFieldWithDefault(this,31,false);
};



proto.mti.store.nxdi.State.prototype.setPuckDeepSleep=function(value){
jspb.Message.setProto3BooleanField(this,31,value);
};








proto.mti.store.nxdi.State.prototype.getPuckShutdown=function(){
return jspb.Message.getFieldWithDefault(this,32,false);
};



proto.mti.store.nxdi.State.prototype.setPuckShutdown=function(value){
jspb.Message.setProto3BooleanField(this,32,value);
};








proto.mti.store.nxdi.State.prototype.getPuckTether=function(){
return jspb.Message.getFieldWithDefault(this,33,false);
};



proto.mti.store.nxdi.State.prototype.setPuckTether=function(value){
jspb.Message.setProto3BooleanField(this,33,value);
};








proto.mti.store.nxdi.State.prototype.getPuckSwitchOpen=function(){
return jspb.Message.getFieldWithDefault(this,34,false);
};



proto.mti.store.nxdi.State.prototype.setPuckSwitchOpen=function(value){
jspb.Message.setProto3BooleanField(this,34,value);
};








proto.mti.store.nxdi.State.prototype.getBaseLostCommunication=function(){
return jspb.Message.getFieldWithDefault(this,35,false);
};



proto.mti.store.nxdi.State.prototype.setBaseLostCommunication=function(value){
jspb.Message.setProto3BooleanField(this,35,value);
};








proto.mti.store.nxdi.State.prototype.getBaseCharging=function(){
return jspb.Message.getFieldWithDefault(this,36,false);
};



proto.mti.store.nxdi.State.prototype.setBaseCharging=function(value){
jspb.Message.setProto3BooleanField(this,36,value);
};








proto.mti.store.nxdi.State.prototype.getBasePowered=function(){
return jspb.Message.getFieldWithDefault(this,37,false);
};



proto.mti.store.nxdi.State.prototype.setBasePowered=function(value){
jspb.Message.setProto3BooleanField(this,37,value);
};








proto.mti.store.nxdi.State.prototype.getBaseShutdown=function(){
return jspb.Message.getFieldWithDefault(this,38,false);
};



proto.mti.store.nxdi.State.prototype.setBaseShutdown=function(value){
jspb.Message.setProto3BooleanField(this,38,value);
};








proto.mti.store.nxdi.State.prototype.getBaseOutputDisabled=function(){
return jspb.Message.getFieldWithDefault(this,39,false);
};



proto.mti.store.nxdi.State.prototype.setBaseOutputDisabled=function(value){
jspb.Message.setProto3BooleanField(this,39,value);
};








proto.mti.store.nxdi.State.prototype.getBaseOutputOvercurrent=function(){
return jspb.Message.getFieldWithDefault(this,40,false);
};



proto.mti.store.nxdi.State.prototype.setBaseOutputOvercurrent=function(value){
jspb.Message.setProto3BooleanField(this,40,value);
};








proto.mti.store.nxdi.State.prototype.getBaseButtonLifted=function(){
return jspb.Message.getFieldWithDefault(this,41,false);
};



proto.mti.store.nxdi.State.prototype.setBaseButtonLifted=function(value){
jspb.Message.setProto3BooleanField(this,41,value);
};








proto.mti.store.nxdi.State.prototype.getShellLostCommunication=function(){
return jspb.Message.getFieldWithDefault(this,42,false);
};



proto.mti.store.nxdi.State.prototype.setShellLostCommunication=function(value){
jspb.Message.setProto3BooleanField(this,42,value);
};








proto.mti.store.nxdi.State.prototype.getShellCharging=function(){
return jspb.Message.getFieldWithDefault(this,43,false);
};



proto.mti.store.nxdi.State.prototype.setShellCharging=function(value){
jspb.Message.setProto3BooleanField(this,43,value);
};








proto.mti.store.nxdi.State.prototype.getShellPowered=function(){
return jspb.Message.getFieldWithDefault(this,44,false);
};



proto.mti.store.nxdi.State.prototype.setShellPowered=function(value){
jspb.Message.setProto3BooleanField(this,44,value);
};








proto.mti.store.nxdi.State.prototype.getShellShutdown=function(){
return jspb.Message.getFieldWithDefault(this,45,false);
};



proto.mti.store.nxdi.State.prototype.setShellShutdown=function(value){
jspb.Message.setProto3BooleanField(this,45,value);
};








proto.mti.store.nxdi.State.prototype.getShellOutputDisabled=function(){
return jspb.Message.getFieldWithDefault(this,46,false);
};



proto.mti.store.nxdi.State.prototype.setShellOutputDisabled=function(value){
jspb.Message.setProto3BooleanField(this,46,value);
};








proto.mti.store.nxdi.State.prototype.getShellOutputOvercurrent=function(){
return jspb.Message.getFieldWithDefault(this,47,false);
};



proto.mti.store.nxdi.State.prototype.setShellOutputOvercurrent=function(value){
jspb.Message.setProto3BooleanField(this,47,value);
};








proto.mti.store.nxdi.State.prototype.getShellBatterySwollenAlarming=function(){
return jspb.Message.getFieldWithDefault(this,48,false);
};



proto.mti.store.nxdi.State.prototype.setShellBatterySwollenAlarming=function(value){
jspb.Message.setProto3BooleanField(this,48,value);
};








proto.mti.store.nxdi.State.prototype.getShellBatteryChargeCycleAlert=function(){
return jspb.Message.getFieldWithDefault(this,49,false);
};



proto.mti.store.nxdi.State.prototype.setShellBatteryChargeCycleAlert=function(value){
jspb.Message.setProto3BooleanField(this,49,value);
};








proto.mti.store.nxdi.State.prototype.getArmed=function(){
return jspb.Message.getFieldWithDefault(this,50,false);
};



proto.mti.store.nxdi.State.prototype.setArmed=function(value){
jspb.Message.setProto3BooleanField(this,50,value);
};








proto.mti.store.nxdi.State.prototype.getKeyInserted=function(){
return jspb.Message.getFieldWithDefault(this,51,false);
};



proto.mti.store.nxdi.State.prototype.setKeyInserted=function(value){
jspb.Message.setProto3BooleanField(this,51,value);
};








proto.mti.store.nxdi.State.prototype.getSilentAlarming=function(){
return jspb.Message.getFieldWithDefault(this,52,false);
};



proto.mti.store.nxdi.State.prototype.setSilentAlarming=function(value){
jspb.Message.setProto3BooleanField(this,52,value);
};








proto.mti.store.nxdi.State.prototype.getPuckSwitchAlarming=function(){
return jspb.Message.getFieldWithDefault(this,53,false);
};



proto.mti.store.nxdi.State.prototype.setPuckSwitchAlarming=function(value){
jspb.Message.setProto3BooleanField(this,53,value);
};








proto.mti.store.nxdi.State.prototype.getTetherAlarming=function(){
return jspb.Message.getFieldWithDefault(this,54,false);
};



proto.mti.store.nxdi.State.prototype.setTetherAlarming=function(value){
jspb.Message.setProto3BooleanField(this,54,value);
};








proto.mti.store.nxdi.State.prototype.getCable0Alarming=function(){
return jspb.Message.getFieldWithDefault(this,55,false);
};



proto.mti.store.nxdi.State.prototype.setCable0Alarming=function(value){
jspb.Message.setProto3BooleanField(this,55,value);
};








proto.mti.store.nxdi.State.prototype.getCable1Alarming=function(){
return jspb.Message.getFieldWithDefault(this,56,false);
};



proto.mti.store.nxdi.State.prototype.setCable1Alarming=function(value){
jspb.Message.setProto3BooleanField(this,56,value);
};








proto.mti.store.nxdi.State.prototype.getDemoMode=function(){
return jspb.Message.getFieldWithDefault(this,57,false);
};



proto.mti.store.nxdi.State.prototype.setDemoMode=function(value){
jspb.Message.setProto3BooleanField(this,57,value);
};








proto.mti.store.nxdi.State.prototype.getCable0SwitchOpen=function(){
return jspb.Message.getFieldWithDefault(this,58,false);
};



proto.mti.store.nxdi.State.prototype.setCable0SwitchOpen=function(value){
jspb.Message.setProto3BooleanField(this,58,value);
};








proto.mti.store.nxdi.State.prototype.getCable1SwitchOpen=function(){
return jspb.Message.getFieldWithDefault(this,59,false);
};



proto.mti.store.nxdi.State.prototype.setCable1SwitchOpen=function(value){
jspb.Message.setProto3BooleanField(this,59,value);
};








proto.mti.store.nxdi.State.prototype.getCableVbusDisabled=function(){
return jspb.Message.getFieldWithDefault(this,60,false);
};



proto.mti.store.nxdi.State.prototype.setCableVbusDisabled=function(value){
jspb.Message.setProto3BooleanField(this,60,value);
};








proto.mti.store.nxdi.State.prototype.getCableVbusFault=function(){
return jspb.Message.getFieldWithDefault(this,61,false);
};



proto.mti.store.nxdi.State.prototype.setCableVbusFault=function(value){
jspb.Message.setProto3BooleanField(this,61,value);
};





proto.mti.store.nxdi.ShellType={
NOSMARTSHELLCONNECTED:0,
SHELL2:1,
UNKNOWNSHELLCONNECTED:255};





proto.mti.store.nxdi.ShellCableType={
NOCABLECONNECTED:0,
NOCHIPID425V:1,
NOCHIPID845V:2,
CHIPID425V:31,
CHIPID845V:32,
PORTNOTSUPPORTED:254,
UNKNOWNCABLECONNECTED:255};


goog.object.extend(exports,proto.mti.store.nxdi);